import React, { useRef, forwardRef, useContext } from "react";
import { BryntumGrid } from "@bryntum/schedulerpro-react";
import { TASK_VIEW_GRID_CONFIG } from "../../other/constants/TaskViewGridConfig.js";
import BryntumContext from "../context/bryntumContext.jsx";
import { EDITOR_KEYS } from "../../other/constants/EditorKeys.jsx";
import { canOpenEditor, debounce, onTaskGridColumnDrop } from "../../other/utils/otherUtils.jsx";
import {GRANTS} from "../../other/constants/PrivilegeTypes.jsx";
import { getOriginalRecord } from "../../other/utils/utils.jsx";
import { ENTITY_TYPES } from "@/other/constants/OtherKeys.jsx";

const BryntumGridWrapper = forwardRef(({ onTaskFind, ...props }, ref) => {
  const context = useContext(BryntumContext);
  const grid = useRef(null);

  const onGridCellClick = debounce(({ column, record, event }) => {
    const originalRecord = getOriginalRecord(record);

    if (canOpenEditor(column, originalRecord) && event.detail === 1 && (column.isTagColumnBase || column.isTeamColumn || column.isTaskBudgetTitleColumn || column.isClientColumn)) {
        context.editorHandler.openEditor(EDITOR_KEYS.entityTagEditor, null, {
          entityRecord: originalRecord,
          event,
          column
        }, { by: "recordType", useExisting: true });
    }
  }, 300);

  return (
    <>
      <BryntumGrid
        {...props}
        {...TASK_VIEW_GRID_CONFIG}
        ref={ref || grid}
        onColumnDrop={onTaskGridColumnDrop(["locked"])}
        disabled={context.user && !context.user.can(GRANTS.grant_four)}
        readOnly={context.user && !context.user.can(GRANTS.grant_four)}
        onCellClick={onGridCellClick}
        onCellDblClick={(e) => {
          const { record, column } = e;
          const originalRecord = getOriginalRecord(record);
          if (canOpenEditor(column, originalRecord)) {
            if (column.isBudgetAccountColumn) {
              if (originalRecord.budgetId && context.user.can(GRANTS.grant_two)) {
                const budgetRecord = context.project.taskBudgetStore.getById(originalRecord.budgetId);
                if (budgetRecord) {
                  context.editorHandler.openEditor(EDITOR_KEYS.budgetEditor, budgetRecord, {
                    budget: budgetRecord,
                  });
                }
              }
            } else {
              context.entityManager.openEntityManager({ entityType: ENTITY_TYPES.TASK, entityId: originalRecord.id });
            }
          }
        }}
        onHeaderMenuItem={({ source, item, point }) => {
          if (item._menuId === "task") {
            const newRecord = source.store.createRecord();
            context.editorHandler.openEditor(EDITOR_KEYS.taskEditor, newRecord, {
              task: newRecord
            });
          } else if (item._menuId === "taskFinder") {
            onTaskFind({ source, point });
          }
        }}
        stateId={props.stateId}
      />
    </>
  );
});

export default BryntumGridWrapper;
